import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterStateService {

  private filters: Record<string, any> | null = null;

  save(filters: Record<string, any>): void {
    this.filters = { ...filters };
  }

  get(): Record<string, any> | null {
    return this.filters ? { ...this.filters } : null;
  }

  clear(): void {
    this.filters = null;
  }

  has(): boolean {
    return this.filters !== null;
  }
}